import axiosInstance from '../api/axiosConfig';
import { EmpresaPermitida, EmpresaPermitidaCreateRequest } from '../../types';

const API_BASE = '/empresas-permitidas';

export const buscarEmpresaPermitidaPorId = async (id: number): Promise<EmpresaPermitida> => {
  const response = await axiosInstance.get(`${API_BASE}/${id}`);
  return response.data;
};

export const criarEmpresaPermitida = async (empresa: EmpresaPermitidaCreateRequest): Promise<EmpresaPermitida> => {
  const response = await axiosInstance.post(API_BASE, empresa);
  return response.data;
};

export const excluirEmpresaPermitida = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${API_BASE}/${id}`);
};

export const buscarTodasEmpresasPermitidas = async (): Promise<EmpresaPermitida[]> => {
  const response = await axiosInstance.get(`${API_BASE}/all`);
  return response.data;
};

export const contarEmpresasPermitidas = async (): Promise<number> => {
  const response = await axiosInstance.get(`${API_BASE}/count`);
  return response.data;
};
